import axios from "../../axios";
import config from '../../config';
import { usePersistedStore } from "../persisted-store";

export const createReceiptsSlice = (set, get) => ({
    receipts: {
        loading: false,
        rceipts: [],
        report: [],
        filtered: []
    },

    getSupportReport: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ receipts: { ...state.receipts, loading: true } }));
        try {
            const resp = await axios({
                method: "get",
                baseURL: config.apiUrls(),
                url: "/v1/business/Receipt-Report",
                headers: { token }
            });
            set(state => ({
                receipts: {
                    ...state.receipts,
                    loading: false,
                    report: resp.data.Items,
                    filtered: resp.data.Items
                }
            }));
        } catch (error) {
            set(state => ({ receipts: { ...state.receipts, loading: false } }));
        }
    },

    filterSupport: (value) => {
        const { report } = get().receipts;
        const payload = report.filter((item) => {
            return (
                item.FullName.includes(value) ||
                (item.TrackingCode && item.TrackingCode.includes(value.toUpperCase())) ||
                (item.UserName && item.UserName.includes(value)) ||
                (item.CompanyName && item.CompanyName.includes(value)) ||
                (item.InsuranceTypeName && item.InsuranceTypeName.includes(value)) ||
                (item.InsuranceRequestId && item.InsuranceRequestId.toString().includes(value)) ||
                (item.TrackingCode && item.TrackingCode.includes(value))
            );
        });
        set(state => ({ receipts: { ...state.receipts, filtered: payload } }));
    },

    getReceipts: async (params) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ receipts: { ...state.receipts, loading: true } }));
        try {
            const resp = await axios({
                method: 'get',
                baseURL: config.apiUrls(),
                url: params.type ?
                    `/v1/business/Paid-Receipt-Report/${params.fromDate}/${params.toDate}/${params.type}` :
                    `/v1/business/Paid-Receipt-Report/${params.fromDate}/${params.toDate}`,
                headers: { token }
            });
            set(state => ({ receipts: { ...state.receipts, loading: false, rceipts: resp.data.Items } }));
        } catch (error) {
            set(state => ({ receipts: { ...state.receipts, loading: false } }));
        }
    }
});
